export const tradexAllowedDomain = [
	"nus.edu.sg"
];
